import { Loader, type LoaderProps, Box, type BoxProps, LoadingOverlay } from "@mantine/core";
import "./InlineLoading.scss";

import clsx from "clsx";
import * as React from "react";

interface IInlineLoadingProps {
    size?: LoaderProps["size"];
    text?: string;
    height?: BoxProps["h"];
    boxProps?: BoxProps;
}

class InlineLoading extends React.Component<IInlineLoadingProps, any> {
    render() {
        const { size = "md", text, height, boxProps } = this.props;

        const loaderBoxProps = height ? boxProps : {};

        const loader = (
            <Box {...loaderBoxProps} className={clsx("inline-loading", boxProps?.className)}>
                <Loader mx="auto" my={size} color="secondary" type="bars" />
                {text}
            </Box>
        );

        if (height) {
            return (
                <Box pos="relative" h={height} {...boxProps}>
                    <LoadingOverlay
                        visible={true}
                        zIndex={1000}
                        loaderProps={{
                            children: loader,
                        }}
                    />
                </Box>
            );
        }

        return loader;
    }
}
export default InlineLoading;
